// Mock data for Claim Beast Public Adjusters - Riverview, FL

export const businessInfo = {
  name: "Claim Beast Public Adjusters",
  shortName: "Claim Beast",
  phone: "(386) 747-9440",
  phoneRaw: "+13867479440",
  emailJoe: "Joe@claimbeast.com",
  emailVictoria: "Victoria@claimbeast.com",
  address: {
    city: "Riverview",
    state: "FL",
    region: "Tampa Bay Area",
  },
  licenses: {
    firm: "G283331",
    florida: "W757540",
    georgia: "3750441",
  },
  social: {
    facebook: "https://www.facebook.com/claimbeast/",
    googleBusiness: "https://maps.google.com/?cid=129351785190383915",
  },
};

export const stats = [
  { value: "$10.3M+", label: "RECOVERED" },
  { value: "425+", label: "CLAIMS SETTLED" },
  { value: "$0", label: "UPFRONT COST" },
];

export const navLinks = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/#services" },
  { label: "Claim Calculator", href: "/claim-calculator" },
  { label: "Meet The Beasts", href: "/about" },
  { label: "Reviews", href: "/reviews" },
  { label: "Guides", href: "/guides" },
  { label: "Blog", href: "/blog" },
  { label: "Service Areas", href: "/#service-areas" },
  { label: "Contact", href: "/#contact" },
];

export const services = [
  {
    id: "wind-damage",
    title: "WIND DAMAGE",
    icon: "Wind",
    description:
      "Roof lifted, siding torn, windows shattered. Every wind-related loss, precisely documented and fought for across the Tampa Bay area.",
  },
  {
    id: "fire-damage",
    title: "FIRE DAMAGE",
    icon: "Flame",
    description:
      "We fight for full replacement value — not the depreciated lowball offers insurers try to settle with after a fire.",
  },
  {
    id: "denied-claims",
    title: "DENIED CLAIMS",
    icon: "Ban",
    description:
      "A denial is not the end. We specialize in overturning wrongful denials and underpaid settlements across Florida.",
  },
  {
    id: "flood-damage",
    title: "FLOOD DAMAGE",
    icon: "Waves",
    description:
      "Rising water destroys more than you see. We document every hidden loss insurers routinely miss or ignore.",
  },
  {
    id: "hail-damage",
    title: "HAIL DAMAGE",
    icon: "CloudHail",
    description:
      "Hail damage is chronically underpaid. We know exactly what to look for and how to prove every dollar.",
  },
  {
    id: "smoke-damage",
    title: "SMOKE DAMAGE",
    icon: "Cloud",
    description:
      "Smoke penetrates everything. We make sure remediation and full replacement costs are covered completely.",
  },
  {
    id: "water-damage",
    title: "WATER DAMAGE",
    icon: "Droplets",
    description:
      "Burst pipes, roof leaks, appliance failures — we trace and prove every dollar of water damage.",
  },
  {
    id: "mold-damage",
    title: "MOLD DAMAGE",
    icon: "Sprout",
    description:
      "We document the source, spread, and full remediation cost so insurers can't minimize your payout.",
  },
  {
    id: "biohazard-bodily-fluid-claims-florida",
    title: "BIOHAZARD & BODILY FLUID",
    icon: "Biohazard",
    description:
      "Blood, trauma, unattended death, and hoarding cleanup. We document the full certified remediation your policy owes — with discretion and care.",
  },
];

export const whyUs = [
  {
    number: "01",
    title: "FLORIDA EXPERTISE",
    description:
      "We know Florida insurance law, building codes, and storm patterns better than anyone — and we use that to win.",
  },
  {
    number: "02",
    title: "WE HANDLE EVERYTHING",
    description:
      "Filing, inspections, estimates, paperwork, negotiations — we manage every step so you don't have to lift a finger.",
  },
  {
    number: "03",
    title: "NO WIN NO FEE",
    description:
      "Zero upfront costs. We work on pure contingency and only earn when you receive a better settlement.",
  },
  {
    number: "04",
    title: "RELENTLESS NEGOTIATORS",
    description:
      "Known for precision documentation and aggressive advocacy. We don't accept the first offer. Ever.",
  },
];

export const processSteps = [
  {
    step: "STEP 1",
    title: "FREE CLAIM REVIEW",
    description:
      "We inspect your property damage, review your policy, and determine the true value of your claim.",
    icon: "ClipboardCheck",
  },
  {
    step: "STEP 2",
    title: "WE FIGHT THE INSURANCE COMPANY",
    description:
      "We document every detail, prepare estimates, attend inspections, manage communications, and negotiate on your behalf.",
    icon: "Swords",
  },
  {
    step: "STEP 3",
    title: "YOU GET PAID WHAT YOU DESERVE",
    description:
      "Once the insurance company agrees to a fair settlement, you receive your payout — often significantly higher than the initial offer.",
    icon: "Banknote",
  },
];

export const serviceAreas = [
  "Riverview",
  "Tampa",
  "Brandon",
  "Apollo Beach",
  "Ruskin",
  "Sun City Center",
  "Wesley Chapel",
  "Plant City",
  "Lutz",
  "Valrico",
  "Town N Country",
  "Carrollwood",
  "Temple Terrace",
  "Odessa",
  "Trinity",
  "Keystone",
  "FishHawk",
  "Gibsonton",
  "Bloomingdale",
];

export const faqs = [
  {
    question: "WHAT IS A PUBLIC ADJUSTER?",
    answer:
      "A public adjuster represents YOU — not the insurance company — during the claims process, ensuring you receive a full and fair settlement under Florida law.",
  },
  {
    question: "DO YOU CHARGE UPFRONT FEES?",
    answer:
      "Never. We work strictly on contingency — meaning we only get paid if we increase your claim payout. Zero risk to you.",
  },
  {
    question: "CAN YOU HELP IF MY CLAIM WAS DENIED?",
    answer:
      "Absolutely. We specialize in overturning denied claims and negotiating significantly higher payouts for underpaid settlements.",
  },
  {
    question: "HOW LONG DOES THE PROCESS TAKE?",
    answer:
      "Every claim is different, but we work as efficiently as possible while maximizing your settlement. You'll receive frequent updates throughout.",
  },
  {
    question: "DO YOU SERVE THE ENTIRE TAMPA BAY AREA?",
    answer:
      "Yes. Based in Riverview, we serve Tampa, Brandon, Apollo Beach, Wesley Chapel, Plant City, and every surrounding city in Hillsborough and Pasco counties.",
  },
  {
    question: "HOW SOON SHOULD I CALL AFTER DAMAGE OCCURS?",
    answer:
      "As soon as possible. Florida has strict claim deadlines, and early documentation dramatically increases your chances of a maximum payout.",
  },
];

export const images = {
  heroRhino:
    "https://images.unsplash.com/photo-1541414779316-956a5084c0d4?auto=format&fit=crop&w=2000&q=80",
  storm:
    "https://images.unsplash.com/photo-1508697014387-db70aad34f4d?auto=format&fit=crop&w=2000&q=80",
  tampa:
    "https://images.unsplash.com/photo-1561063139-09996cdf3f49?auto=format&fit=crop&w=2000&q=80",
  hurricane:
    "https://images.unsplash.com/photo-1544257750-572358f5da22?auto=format&fit=crop&w=1600&q=80",
  fire:
    "https://images.unsplash.com/photo-1762291329593-9c90ab7947bf?auto=format&fit=crop&w=1600&q=80",
  flood:
    "https://images.pexels.com/photos/28447776/pexels-photo-28447776.jpeg?auto=compress&w=1600",
  roof:
    "https://images.unsplash.com/photo-1669215526577-c25a8f063677?auto=format&fit=crop&w=1600&q=80",
  negotiation:
    "https://images.unsplash.com/photo-1681505531034-8d67054e07f6?auto=format&fit=crop&w=1600&q=80",
};
